var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18602 4.01935C3.22509 3.98028 3.27808 3.95833 3.33333 3.95833H16.6667C16.7219 3.95833 16.7749 3.98028 16.814 4.01935C16.8531 4.05842 16.875 4.11141 16.875 4.16667V12.5C16.875 12.5553 16.8531 12.6082 16.814 12.6473C16.7749 12.6864 16.7219 12.7083 16.6667 12.7083H12.5H7.5H3.33333C3.27808 12.7083 3.22509 12.6864 3.18602 12.6473C3.14695 12.6082 3.125 12.5553 3.125 12.5V4.16667C3.125 4.11141 3.14695 4.05842 3.18602 4.01935ZM13.125 13.9583H16.6667C17.0534 13.9583 17.4244 13.8047 17.6979 13.5312C17.9714 13.2577 18.125 12.8868 18.125 12.5V4.16667C18.125 3.77989 17.9714 3.40896 17.6979 3.13547C17.4244 2.86198 17.0534 2.70833 16.6667 2.70833H3.33333C2.94656 2.70833 2.57563 2.86198 2.30214 3.13547C2.02865 3.40896 1.875 3.77989 1.875 4.16667V12.5C1.875 12.8868 2.02865 13.2577 2.30214 13.5312C2.57563 13.8047 2.94656 13.9583 3.33333 13.9583H6.875V16.0417H5.83333C5.48816 16.0417 5.20833 16.3215 5.20833 16.6667C5.20833 17.0118 5.48816 17.2917 5.83333 17.2917H7.5H12.5H14.1667C14.5118 17.2917 14.7917 17.0118 14.7917 16.6667C14.7917 16.3215 14.5118 16.0417 14.1667 16.0417H13.125V13.9583ZM11.875 13.9583H8.125V16.0417H11.875V13.9583Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.d870a5713d8bd8bc294db214308c9961.svg";
export { ForwardRef as ReactComponent };